import { EqExpression } from "../../../Models/Comparators/EqExpression";
import { IExpressionEvaluator, IHasExpressionMetadata } from "../../../Models/IExpressionEvaluator";
import { MaybePromise } from "../../../Models/MaybePromise";
import { IExpressionEvaluatorContext } from "../../../Models/IExpressionEvaluatorContext";

export class EqExpressionEvaluator implements IExpressionEvaluator<EqExpression>, IHasExpressionMetadata {
  private static _expressionPropertyNames: string[] = ["Value"];

  get expressionProperties(): string[] {
    return EqExpressionEvaluator._expressionPropertyNames;
  }
  get type(): string {
    return "Eq";
  }

  evaluate(expression: EqExpression, context: IExpressionEvaluatorContext): MaybePromise {
    if (!expression.Value || expression.Value.length === 0) {
      return true;
    }

    // Evaluate all expressions
    const results: any[] = [];
    let hasPromise = false;

    for (const valueExpression of expression.Value) {
      const value = context.Evaluator.evaluate(valueExpression, context);
      results.push(value);
      if (value instanceof Promise) {
        hasPromise = true;
      }
    }

    // If any promise exists, wait for all and then compare
    if (hasPromise) {
      return Promise.all(results).then((values) => this.checkEquality(values));
    }

    // All sync, check immediately
    return this.checkEquality(results);
  }

  private checkEquality(values: any[]): boolean {
    const firstValue = values[0];
    for (let i = 1; i < values.length; i++) {
      if (values[i] !== firstValue) {
        return false;
      }
    }
    return true;
  }
}



